/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class GroupsRoute extends Route {
  queryParams = {
    year: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  model(params) {
    let schoolId = this.get('session.activeSchool');
    let year = params.year || moment().format('YYYY');
    return hash({
      groups: this.store.query('group', {
        schoolId,
        year,
        groupType: GroupType.HOMEROOM,
      }),
    });
  }
}
